const modulePages = [
	{
		id: 'm5-page-1',
		isFacilitatorOnly: false,
		title: 'TANKELABYRINTER',
		facilitatorText: `Gå til www.basalsammen.dk. Skriv kode i elevlogin.
			<br /><br /><span><%GAMECODE%></span>`,
		groupText: `Vælg et udsagn, og træk det hen til den tankelabyrint, I mener den passer til. Tryk OK, når I mener, I har placeret dem rigtigt.`,
		icons: [],
		slides: [
			{
				type: 'video',
				videoType: 'ignite',
				videoLink: 'https://kfs.euvideocdn.com/player/index.html?id=6a425fe4ac55558c81793eea',
				text: 'SE VIDEO',
				roles: ['facilitator']
			},
			{
				id: 'm5-slide',
				type: 'image', 
				text: 'SLIDE',
				roles: ['facilitator']
			}
		],
		minigames: [
			require('data/minigames/m5-thought-mazes').minigameData
		]
	},
	{
		id: 'm5-page-2',
		isFacilitatorOnly: true,
		title: 'OPMÆRKSOMHED',
		facilitatorText: null,
		icons: [],
		slides: [
			{
				type: 'video',
				videoType: 'youtube',
				videoId: 'KB_lTKZm1Ts',
				text: 'SE VIDEO'
			},
			{
				id: 'm5-slide-2',
				type: 'image',
				text: 'SLIDE'
			},
			{
				id: 'm5-aktiv-ovelse',
				type: 'image',
				text: 'AKTIV ØVELSE'
			},
			{
				id: 'iderunde',
				type: 'image', 
				text: 'IDÉRUNDE'
			},
			{
				id: 'm5-basalboxen',
				type: 'image',
				text: 'BASALBOXEN'
			}
		
		]	
	},

	{
		id: 'm5-page-3',
		isFacilitatorOnly: true,
		title: 'BASALPLAN',
		facilitatorText: null,
		groupText: null,
		icons: [],
		slides: [
			{
				id: 'm5-case',
				type: 'image',
				text: 'CASE'
			},
			{
				id: 'm5-ovelse',
				type: 'image', 
				text: 'ØVELSE'
			},
		],
	}
];


export {
	modulePages
};